import React, {useEffect, useState} from 'react'
import {useParams, useHistory} from 'react-router-dom'
import Navbar from "../components/navbar"
import Menu from "../components/menu"
//---REDUX
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import allTheActions from '../actions'
//---
import TitleH1 from "../components/titleH1"
import HorizontalAlign from "../components/horizontalAlign"
import Image from "../components/image"
import Popup from "../components/popupSwal"
import FormClub from "../components/formClub"
import MenuMember from "../components/menuMember"

const ClubSettings = props => {
    const params = useParams()
    const history = useHistory()
    const [club, setClub] = useState({})
    const [file, setFile] = useState(null)

    useEffect(() => {
        const fetchClub = async () => {
            setClub(await props.actions.club.getOne(params.id))
        }
        fetchClub()
    }, [props.actions.club, params.id])

    const handleChangeFile = event => {
        setFile(event.target.files[0])
        setClub({...club, photo: event.target.files[0].name})
    }

    const handleChange = event => {
        setClub({...club, [event.target.name]: event.target.value})
    }

    const handleChangeRadio = event => {
        setClub({...club, affiliation: event})
    }

    const handleSubmit = async event => {
        event.preventDefault()
        const fileData = new FormData()
        fileData.append('file', file)

        if (await props.actions.club.update(club) && await props.actions.club.photo(fileData, params.id))
            Popup("Tout est good !", "Mise à jour des informations du club réussie !", () => history.push(`/club/${params.id}`))
    }

    return (
        <div>
            <Navbar/>
            {(localStorage.getItem('admin') === 'true') ? <Menu/> : <MenuMember/>}
            <HorizontalAlign content={
                <>
                    <TitleH1 content={club.nom}/>
                    {club.photo ? <Image src={`https://khaktus.fr/3fts/${club._id}/${club.photo}`} height="75px"
                    /> : null}
                </>
            }/>
            <FormClub
                handleChange={handleChange}
                handleChangeFile={handleChangeFile}
                handleChangeRadio={handleChangeRadio}
                handleSubmit={handleSubmit}
                club={club}
                affiliation={(club.affiliation !== undefined) ? club.affiliation.toString() : null}
            />
        </div>
    )
}

const mapStateToProps = state => ({
    licenceState: state.licence,
    clubState: state.club
})

const mapDispatchToProps = () => dispatch => ({
    actions: {
        licence: bindActionCreators(allTheActions.licence, dispatch),
        club: bindActionCreators(allTheActions.club, dispatch)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(ClubSettings)
